import React, { useRef, useState } from 'react';
import { Close } from '@material-ui/icons';
import { DropZone, DropZoneContent, IconWrapper, TextContainer, UploadLink, FilesPreviewContainer, FilePreviewItem, FilePreviewImage, FilePreviewInfo, FilePreviewName, FilePreviewSize, FilePreviewRemoveButton, FilePreviewIcon, } from './styles';
import { FileThumbPdfIcon } from 'src/assets/Images';
import UploadFileFilledIcon from 'src/assets/Images/UploadFileFilled.svg';
import { generateFilePreviews } from 'src/Utils/filePreviewUtils';
var DragAndDrop = function (_a) {
    var onFilesSelected = _a.onFilesSelected, _b = _a.files, files = _b === void 0 ? [] : _b, onRemoveFile = _a.onRemoveFile, _c = _a.accept, accept = _c === void 0 ? 'application/pdf,image/jpeg,image/jpg,image/png' : _c, _d = _a.multiple, multiple = _d === void 0 ? true : _d, className = _a.className;
    var fileInputRef = useRef(null);
    var _e = React.useState(false), isDragging = _e[0], setIsDragging = _e[1];
    var _f = useState([]), filePreviews = _f[0], setFilePreviews = _f[1];
    React.useEffect(function () {
        if (files.length > 0) {
            generateFilePreviews(files).then(setFilePreviews);
        }
        else {
            setFilePreviews([]);
        }
    }, [files]);
    var handleDragEnter = function (e) {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
    };
    var handleDragLeave = function (e) {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
    };
    var handleDragOver = function (e) {
        e.preventDefault();
        e.stopPropagation();
    };
    var handleDrop = function (e) {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
        var files = Array.from(e.dataTransfer.files);
        var validFiles = files.filter(function (file) {
            var fileType = file.type;
            var fileName = file.name.toLowerCase();
            if (!fileType && !fileName) {
                return false;
            }
            var isValidType = accept.split(',').some(function (type) {
                var trimmedType = type.trim().toLowerCase();
                if (fileType) {
                    if (fileType === trimmedType || fileType.startsWith(trimmedType.split('/')[0] + '/')) {
                        return true;
                    }
                }
                if (trimmedType === 'application/pdf') {
                    return fileName.endsWith('.pdf');
                }
                if (trimmedType.includes('image')) {
                    return /\.(png|jpe?g|gif|webp|svg)$/i.test(fileName);
                }
                var parts = trimmedType.split('/');
                if (parts.length === 2) {
                    var extension = parts[1];
                    return fileName.endsWith("." + extension);
                }
                return false;
            });
            return isValidType;
        });
        if (validFiles.length > 0) {
            onFilesSelected(validFiles);
        }
    };
    var handleFileInputChange = function (e) {
        var files = e.target.files ? Array.from(e.target.files) : [];
        if (files.length > 0) {
            onFilesSelected(files);
        }
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };
    var handleUploadClick = function () {
        var _a;
        (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    var formatFileSize = function (bytes) {
        if (bytes === 0)
            return '0 Bytes';
        var k = 1024;
        var sizes = ['Bytes', 'KB', 'MB'];
        var i = Math.floor(Math.log(bytes) / Math.log(k));
        return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
    };
    var handleRemoveFile = function (index) {
        if (onRemoveFile) {
            onRemoveFile(index);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("input", { ref: fileInputRef, type: "file", accept: accept, multiple: multiple, onChange: handleFileInputChange, style: { display: 'none' } }),
        React.createElement(DropZone, { className: className, isDragging: isDragging, onDragEnter: handleDragEnter, onDragLeave: handleDragLeave, onDragOver: handleDragOver, onDrop: handleDrop },
            React.createElement(DropZoneContent, null,
                React.createElement(IconWrapper, null,
                    React.createElement("img", { src: UploadFileFilledIcon, alt: "Upload" })),
                React.createElement(TextContainer, null,
                    "Puede arrastrar archivos ",
                    React.createElement("strong", null, "PDF"),
                    ", ",
                    React.createElement("strong", null, "JPG"),
                    " o ",
                    React.createElement("strong", null, "PNG"),
                    ", o ",
                    ' ',
                    React.createElement(UploadLink, { onClick: handleUploadClick }, "hacer click ac\u00E1 para cargar uno")))),
        filePreviews.length > 0 && (React.createElement(FilesPreviewContainer, null, filePreviews.map(function (preview, index) { return (React.createElement(FilePreviewItem, { key: preview.file.name + "-" + preview.file.size + "-" + index },
            preview.preview ? (React.createElement(FilePreviewImage, { src: preview.preview, alt: preview.file.name })) : (React.createElement(FilePreviewIcon, null,
                React.createElement("img", { src: FileThumbPdfIcon, alt: "File" }))),
            React.createElement(FilePreviewInfo, null,
                React.createElement(FilePreviewName, null, preview.file.name),
                React.createElement(FilePreviewSize, null, formatFileSize(preview.file.size))),
            React.createElement(FilePreviewRemoveButton, { onClick: function () { return handleRemoveFile(index); } },
                React.createElement(Close, { style: { fontSize: '16px' } })))); })))));
};
export default DragAndDrop;
